import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import Typography from '../../UI/Typography'
import Select from '../../UI/Form/Select'
import ScrollNav from '../../UI/ScrollNav'
import SplitSection from '../../UI/Slider/SplitSection'
import PriceSection from '../../UI/Misc/Price'
import { fetchDurations, fetchProducts } from '../../../actions/calculator'
import TabSlider from '../../UI/TabSlider'
import { device } from '../../../utils/helpers'
import { Element, Events } from 'react-scroll'

import Feature from '../../UI/Feature'
import { features } from './Contenimento'

import {
  calcioSlides1,
  calcioSlides2,
  pingPongSlides1,
  pingPongSlides2,
  pannaSlides1,
  pannaSlides2,
  teqballSlides1,
  teqballSlides2
} from '../../Helpers/Slides'
import CalcioBalillaIcon from '../../UI/Icons/CalcioBalillaIcon'
import PingPongIcon from '../../UI/Icons/PingPongIcon'
import Panna1v1Icon from '../../UI/Icons/Panna1v1Icon'
import TeqBallIcon from '../../UI/Icons/TeqballIcon'

const Icon = ({ icon, ...props }) => (
  // Needed to pass props to the element which is also being
  // passed as props
  React.cloneElement(icon, { ...props })
)

export const StyledIcon = styled(Icon)`
  width: ${props => props.width};
  height: ${props => props.height};

  @media ${device.tablet} {
    width: ${props => props.tabWidth};
    height: ${props => props.tabHeight};
  }
`

const navItems = [
  {
    name: 'Teqball',
    icon: <StyledIcon icon={<TeqBallIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Calcio Balilla',
    icon: <StyledIcon icon={<CalcioBalillaIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Ping Pong',
    icon: <StyledIcon icon={<PingPongIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Panna 1vs1',
    icon: <StyledIcon icon={<Panna1v1Icon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  }
]

const teqball = {
  description: 'Teqball è un nuovo e divertente sport che unisce il calcio al ping-pong. Può essere considerato un’evoluzione diretta del calcio tennis con la differenza che questa variante viene giocata su un tavolo molto speciale, con una specifica curvatura. Il tavolo permette di sperimentare anche altre discipline: teqvolley, teqpong, teqtennis...',
  technical: [
    'Lunghezza: 3 m',
    'Larghezza: 1.7 m (inclusa la rete)',
    'Altezza: 0.9 m (parte superiore della rete)',
    'Materiali dotati di certificazione',
    'Prodotto professionale outdoor',
    'Possibilità di brandizzazione e personalizzazione',
    'Non necessita di ancoraggio al suolo'
  ],
  tabs: [
    {
      title: 'Adesivo',
      content: 'Possibilità di brandizzazione del teqball con adesivo monomerico opaco/lucido resistente all’acqua su tutti e quattro i lati del campo da gioco.',
      goToSlideIndex: 0
    }
  ]
}

const calcio = {
  description: 'Il calcio balilla è sicuramente una delle migliori attività da installare nei villaggi degli eventi sportivi per permettere di ad atleti e spettatori di trascorrere piacevolmente la loro giornata tra un gol dal portiere e una “rullata”.',
  technical: [
    'Calcio balilla professionale',
    'Sistema di recupero palla in goal, da due oblò posti dietro le testate',
    'N10 palline da gioco fornite',
    'Prodotti professionali outdoor',
    'Materiali dotati di certificazione'
  ],
  tabs: [
    {
      title: 'Adesivo',
      content: 'Possibilità di brandizzazione del calcio balilla con adesivo monomerico opaco/lucido resistente all’acqua su tutti e quattro i lati del campo da gioco.',
      goToSlideIndex: 0
    }
  ]
}

const pingpong = {
  description: 'Le sfide al tavolo verde sono sempre state un mood delle estati italiane.;In ogni evento sportivo non può mancare il tavolo da ping pong per far divertire giocatori e spettatori con schiacciate e spigolini vincenti.',
  technical: [
    'Tavolo free Ping Pong FT 720 outdoor',
    'Racchette da gioco e palline',
    'Prodotti professionali outdoor',
    'Materiali dotati di certificazione antiruggine'
  ],
  tabs: [
    {
      title: 'Adesivo',
      content: 'Possibilità di brandizzazione del tavolo da ping pong con adesivo monomerico opaco/lucido resistente all’acqua sull’intera superficie di gioco.',
      goToSlideIndex: 0
    }
  ]
}

const panna = {
  description: 'Due giocatori ed una palla dentro a un cerchio di 6 m.;Le regole sono le seguenti: hai tre minuti per segnare un massimo di goal o fare un tunnel, se alla fine dei tre minuti non viene fatto alcun tunnel vince colui che ha fatto più goal ma se ci dovesse essere un tunnel vince direttamente chi lo fa, senza contare il punteggio dei goal.',
  technical: <div style={{ display: 'flex' }}>
    <div>
      <ul>
        <li>6 metri di diametro</li>
        <li>Materiali dotati di certificazione</li>
        <li>Non necessita di ancoraggio al suolo</li>
        <li>Bordo campo brandizzabili</li>
        <li>Impianto di illuminazione</li>
        <li>Impianto audio e diffusione sonora</li>
      </ul>
    </div>
    <div style={{ marginLeft: '40px' }}>
      <Typography variant='h5' type='subtitle'>SUPERFICIE:</Typography>
      <ul>
        <li>Manto erboso di ultima generazione (altezza 3,5 cm)</li>
        <li>Sistem swiss-flex</li>
        <li>Su terreno presente</li>
      </ul>
    </div>
  </div>,
  tabs: [
    {
      title: 'Adesivo',
      content: 'Possibilità di brandizzazione delle sponde laterali interne/esterne con adesivo monomerico opaco/lucido resistente all’acqua.',
      goToSlideIndex: 0
    }
  ]
}

export const Section = styled.section`
  background: ${props => props.grey ? props.theme.color.bgLight : '#fff'};
  background: ${props => props.light && '#f3f3f3'};
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.div`
  padding: 3.6rem 1.5rem;
  text-align: center;
  background-color: #f3f3f3;
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 100px;
  }
`

export const BigTitle = styled.div`
  padding: 4.5rem 4.5rem 0 4.5rem;
  text-align: center;

  @media ${device.laptop} {
    width: 500px;
  }

  @media ${device.laptopL} {
    width: 700px;
  }
`

export const FeatureWrapper = styled.div`
  padding: 2.5rem 1.5rem;
`

export const Features = styled.div`
  padding: 2.5rem 0;

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }

  @media ${device.laptopM} {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }
`

export const Menu = styled.div`
  background-color: #f3f3f3;
  border-top: 1px solid #4d4d4d;
  padding: 25px 0;
  z-index: 100;

  @media ${device.tablet} {
    padding: 2.083333333333333VW 0;
  }
`

export const Content = styled.div`
  width: 100%;
`

const UList = styled.ul`
  font-size: 21px;
  padding: 0 1.2rem;

  @media ${device.laptop} {
    font-size: 16px;
  }

  @media ${device.laptopM} {
    column-count: 2;
    column-gap: 40px;
    list-style: outside disc;
  }

  @media ${device.laptopL} {
    font-size: 21px;
    column-gap: 50px;
  }
`

const UListNormal = styled.ul`
  font-size: 21px;
  padding: 0 1.2rem;

  @media ${device.laptop} {
    font-size: 16px;
  }

  @media ${device.laptopM} {
    list-style: outside disc;
  }

  @media ${device.laptopL} {
    font-size: 21px;
  }
`

const ListItem = styled.li`
  @media ${device.laptopM} {
    margin-left: 1em
  }
`

export const Customize = styled.div`
  padding-top: 0.5rem;

  @media ${device.laptop} {
    padding-top: 1rem;
  }

  @media ${device.laptopL} {
    padding-top: 3rem;
  }
`

export const CustomizeHeading = styled.p`
  font-size: 24px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  padding: 1rem 0;

  @media ${device.laptop} {
    padding: 0.5rem 0;
  }

  @media ${device.laptopL} {
    padding: 1.2rem 0;
  }
`

export const CustomizeOptions = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.5rem 0;

  @media ${device.laptop} {
    padding: 0.5rem 0;
  }

  @media ${device.desktop} {
    padding: 1.2rem 0;
  }
`

export const FormGroup = styled.div`
  display: flex;
  padding: ${props => props.padding};
  padding-bottom: 20px;

  @media ${device.tablet} {
    width: 30%;
  }
`

class Altre extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sticky: false,
      quantita: [
        {
          id: 1,
          name: '1'
        },
        {
          id: 2,
          name: '2'
        },
        {
          id: 3,
          name: '3'
        },
        {
          id: 4,
          name: '4'
        }
      ],
      currentTeqballQuantita: {
        id: 1,
        name: '1'
      },
      currentTeqballDuration: {},
      currentTeqballAddon: {
        id: 1,
        name: 'NESSUNA',
        amount: 0
      },
      teqballAmount: '',
      currentCalcioQuantita: {
        id: 1,
        name: '1'
      },
      currentCalcioDuration: {},
      currentCalcioAddon: {
        id: 1,
        name: 'NESSUNA',
        amount: 0
      },
      calcioAmount: '',
      currentPannaQuantita: {
        id: 1,
        name: '1'
      },
      currentPannaDuration: {},
      currentPannaAddon: {
        id: 1,
        name: 'NESSUNA',
        amount: 0
      },
      pannaAmount: '',
      currentPingpongQuantita: {
        id: 1,
        name: '1'
      },
      currentPingpongDuration: {},
      currentPingpongAddon: {
        id: 1,
        name: 'NESSUNA',
        amount: 0
      },
      pingpongAmount: ''
    }
  }

  componentDidMount () {
    Events.scrollEvent.register('begin', function () {
      // console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      // console.log('end', arguments)
    })

    window.addEventListener('scroll', this.handleScroll.bind(this))
    this.props.fetchDurations(null, (durations) => {
      this.setState({ currentTeqballDuration: durations[0], currentCalcioDuration: durations[0], currentPannaDuration: durations[0], currentPingpongDuration: durations[0] })
    })
    this.props.fetchProducts((products) => {
      this.setState({ teqballAmount: products[8].amount, calcioAmount: products[6].amount, pannaAmount: products[5].amount, pingpongAmount: products[7].amount })
    })
  }

  handleScroll (event) {
    const sticky = this.menu && this.menu.offsetTop
    // console.log(window.pageYOffset, sticky)
    if (window.pageYOffset > sticky - 100) {
      this.setState({ sticky: true })
    }

    if (window.pageYOffset < 165) {
      this.setState({ sticky: false })
    }
  }

  toggleSelected (id, key) {
    let temp = this.state[key]
    temp[id].selected = !temp[id].selected
    this.setState({ [key]: temp })
  }

  handleTeqballQuantitySelection (item) {
    const { teqballProduct } = this.props
    const { currentTeqballDuration, currentTeqballAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (teqballProduct.amount + (currentTeqballAddon ? currentTeqballAddon.amount : 0))
    let teqballAmount = (baseAmount + (baseAmount * currentTeqballDuration.coefficient)) * item.id
    console.log(teqballAmount)
    this.setState((prevState) => ({
      currentTeqballQuantita: item, teqballAmount
    }))
  }

  handleTeqballDurationSelection (item) {
    const { teqballProduct } = this.props
    const { currentTeqballQuantita, currentTeqballAddon } = this.state
    let baseAmount = (teqballProduct.amount + (currentTeqballAddon ? currentTeqballAddon.amount : 0))
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let teqballAmount = (baseAmount + (baseAmount * item.coefficient)) * currentTeqballQuantita.id
    this.setState((prevState) => ({
      currentTeqballDuration: item, teqballAmount
    }))
  }

  handleTeqballAddonSelection (item) {
    const { teqballProduct } = this.props
    const { currentTeqballQuantita, currentTeqballDuration } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (teqballProduct.amount + (item ? item.amount : 0))
    let teqballAmount = (baseAmount + (baseAmount * currentTeqballDuration.coefficient)) * currentTeqballQuantita.id
    this.setState((prevState) => ({
      currentTeqballAddon: item, teqballAmount
    }))
  }

  handleCalcioQuantitySelection (item) {
    const { calcioProduct } = this.props
    const { currentCalcioDuration, currentCalcioAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (calcioProduct.amount + (currentCalcioAddon ? currentCalcioAddon.amount : 0))
    let calcioAmount = (baseAmount + (baseAmount * currentCalcioDuration.coefficient)) * item.id
    this.setState({ currentCalcioQuantita: item, calcioAmount })
  }

  handleCalcioDurationSelection (item) {
    const { calcioProduct } = this.props
    const { currentCalcioQuantita, currentCalcioAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (calcioProduct.amount + (currentCalcioAddon ? currentCalcioAddon.amount : 0))
    let calcioAmount = (baseAmount + (baseAmount * item.coefficient)) * currentCalcioQuantita.id
    this.setState((prevState) => ({
      currentCalcioDuration: item, calcioAmount
    }))
  }

  handleCalcioAddonSelection (item) {
    const { calcioProduct } = this.props
    const { currentCalcioQuantita, currentCalcioDuration } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (calcioProduct.amount + (item ? item.amount : 0))
    let calcioAmount = (baseAmount + (baseAmount * currentCalcioDuration.coefficient)) * currentCalcioQuantita.id
    this.setState((prevState) => ({
      currentCalcioAddon: item, calcioAmount
    }))
  }

  handlePannaQuantitySelection (item) {
    const { pannaProduct } = this.props
    const { currentPannaDuration, currentPannaAddon } = this.state
    let baseAmount = (pannaProduct.amount + (currentPannaAddon ? currentPannaAddon.amount : 0))
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let pannaAmount = (baseAmount + (baseAmount * currentPannaDuration.coefficient)) * item.id
    this.setState({ currentPannaQuantita: item, pannaAmount })
  }

  handlePannaDurationSelection (item) {
    const { pannaProduct } = this.props
    const { currentPannaQuantita, currentPannaAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (pannaProduct.amount + (currentPannaAddon ? currentPannaAddon.amount : 0))
    let pannaAmount = (baseAmount + (baseAmount * item.coefficient)) * currentPannaQuantita.id
    this.setState((prevState) => ({
      currentPannaDuration: item, pannaAmount
    }))
  }

  handlePannaAddonSelection (item) {
    const { pannaProduct } = this.props
    const { currentPannaQuantita, currentPannaDuration } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (pannaProduct.amount + (item ? item.amount : 0))
    let pannaAmount = (baseAmount + (baseAmount * currentPannaDuration.coefficient)) * currentPannaQuantita.id
    this.setState((prevState) => ({
      currentPannaAddon: item, pannaAmount
    }))
  }

  handlePingpongQuantitySelection (item) {
    const { pingpongProduct } = this.props
    const { currentPingpongDuration, currentPingpongAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (pingpongProduct.amount + (currentPingpongAddon ? currentPingpongAddon.amount : 0))
    let pingpongAmount = (baseAmount + (baseAmount * currentPingpongDuration.coefficient)) * item.id
    this.setState((prevState) => ({
      currentPingpongQuantita: item, pingpongAmount
    }))
  }

  handlePingpongDurationSelection (item) {
    const { pingpongProduct } = this.props
    const { currentPingpongQuantita, currentPingpongAddon } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (pingpongProduct.amount + (currentPingpongAddon ? currentPingpongAddon.amount : 0))
    let pingpongAmount = (baseAmount + (baseAmount * item.coefficient)) * currentPingpongQuantita.id
    this.setState((prevState) => ({
      currentPingpongDuration: item, pingpongAmount
    }))
  }

  handlePingpongAddonSelection (item) {
    const { pingpongProduct } = this.props
    const { currentPingpongQuantita, currentPingpongDuration } = this.state
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let baseAmount = (pingpongProduct.amount + (item ? item.amount : 0))
    let pingpongAmount = (baseAmount + (baseAmount * currentPingpongDuration.coefficient)) * currentPingpongQuantita.id
    this.setState((prevState) => ({
      currentPingpongAddon: item, pingpongAmount
    }))
  }

  render () {
    const { calcioAmount, pannaAmount, pingpongAmount, teqballAmount } = this.state
    const { durations, calcioProduct, pannaProduct, pingpongProduct, teqballProduct } = this.props
    let teqballAddonOptions = [{
      id: 1,
      name: 'NESSUNA',
      amount: 0
    }]
    let calcioAddonOptions = [{
      id: 1,
      name: 'NESSUNA',
      amount: 0
    }]
    let pannaAddonOptions = [{
      id: 1,
      name: 'NESSUNA',
      amount: 0
    }]
    let pingpongAddonOptions = [{
      id: 1,
      name: 'NESSUNA',
      amount: 0
    }]
    teqballProduct && teqballProduct.addons.map((item, i) => {
      if (item.amount) {
        teqballAddonOptions.push({
          id: i + 2,
          name: item.name,
          amount: item.amount
        })
      }
    })
    calcioProduct && calcioProduct.addons.map((item, i) => {
      if (item.amount) {
        calcioAddonOptions.push({
          id: i + 2,
          name: item.name,
          amount: item.amount
        })
      }
    })
    pannaProduct && pannaProduct.addons.map((item, i) => {
      if (item.amount) {
        pannaAddonOptions.push({
          id: i + 2,
          name: item.name,
          amount: item.amount
        })
      }
    })
    pingpongProduct && pingpongProduct.addons.map((item, i) => {
      if (item.amount) {
        pingpongAddonOptions.push({
          id: i + 2,
          name: item.name,
          amount: item.amount
        })
      }
    })
    return (
      <div>
        <Helmet>
          <title>Noleggio Calcio Balilla Ping Pong Gabbia 1v1 Tavolo Teqball</title>
          <meta name='Description' content='Tante strutture collaterali per completare il tuo evento: noleggio calcio balilla, tavolo da ping pong, Calcio 1 contro 1 ed il nuovissimo tavolo Teqball!' />
          <meta name='Keywords' content='tavolo da ping pong,calcio 1 contro 1,teqball,calcio 1 contro 1' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>ALTRE STRUTTURE</Typography>
        </Title>
        <Menu innerRef={menu => (this.menu = menu)} className={this.state.sticky ? 'sticky' : ''}>
          <ScrollNav items={navItems} />
        </Menu>
        <Content>
          {/* TEQBALL */}
          <Element name='teqball' >
            <SplitSection slides={teqballSlides1} reverse reverseMobile>
              <Typography variant='h2' type='title'>TEQBALL</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {teqball.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {teqball.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
            <TabSlider
              slides={teqballSlides2}
              tabs={teqball.tabs}
              title='Personalizzazione'
              customize
            >
              <Customize>
                <CustomizeHeading>NOLEGGIA TEQBALL</CustomizeHeading>
                <CustomizeOptions>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Quantita'
                      list={this.state.quantita}
                      default={this.state.currentTeqballQuantita}
                      selected={this.handleTeqballQuantitySelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Durata'
                      list={durations}
                      default={durations[0]}
                      selected={this.handleTeqballDurationSelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      title='Personalizzazione'
                      list={teqballAddonOptions}
                      default={this.state.currentTeqballAddon}
                      selected={this.handleTeqballAddonSelection.bind(this)}
                    />
                  </FormGroup>
                  <PriceSection
                    product={this.props.teqballProduct}
                    quantity={this.state.currentTeqballQuantita}
                    duration={this.state.currentTeqballDuration}
                    addon={this.state.currentTeqballAddon}
                    amount={teqballAmount}
                  />
                </CustomizeOptions>
              </Customize>
            </TabSlider>
          </Element>
          {/* CALCIO BALILLA */}
          <Element name='calcio balilla' >
            <SplitSection slides={calcioSlides1} reverse reverseMobile>
              <Typography variant='h2' type='title'>CALCIO BALILLA</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {calcio.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {calcio.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
            <TabSlider
              slides={calcioSlides2}
              tabs={calcio.tabs}
              title='Personalizzazione'
              customize
            >
              <Customize>
                <CustomizeHeading>NOLEGGIA CALCIO BALILLA</CustomizeHeading>
                <CustomizeOptions>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Quantita'
                      list={this.state.quantita}
                      default={this.state.currentCalcioQuantita}
                      selected={this.handleCalcioQuantitySelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Durata'
                      list={durations}
                      default={durations[0]}
                      selected={this.handleCalcioDurationSelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      title='Personalizzazione'
                      list={calcioAddonOptions}
                      default={this.state.currentCalcioAddon}
                      selected={this.handleCalcioAddonSelection.bind(this)}
                    />
                  </FormGroup>
                  <PriceSection
                    product={this.props.calcioProduct}
                    quantity={this.state.currentCalcioQuantita}
                    duration={this.state.currentCalcioDuration}
                    addon={this.state.currentCalcioAddon}
                    amount={calcioAmount}
                  />
                </CustomizeOptions>
              </Customize>
            </TabSlider>
          </Element>
          {/* PING-PONG */}
          <Element name='ping pong' >
            <SplitSection slides={pingPongSlides1} reverse>
              <Typography variant='h2' type='title'>PING-PONG</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {pingpong.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {pingpong.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
            <TabSlider
              slides={pingPongSlides2}
              tabs={pingpong.tabs}
              title='Personalizzazione'
              customize
            >
              <Customize>
                <CustomizeHeading>NOLEGGIA PING-PONG</CustomizeHeading>
                <CustomizeOptions>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Quantita'
                      list={this.state.quantita}
                      default={this.state.currentPingpongQuantita}
                      selected={this.handlePingpongQuantitySelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Durata'
                      list={durations}
                      default={durations[0]}
                      selected={this.handlePingpongDurationSelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      title='Personalizzazione'
                      list={pingpongAddonOptions}
                      default={this.state.currentPingpongAddon}
                      selected={this.handlePingpongAddonSelection.bind(this)}
                    />
                  </FormGroup>
                  <PriceSection
                    product={this.props.pingpongProduct}
                    quantity={this.state.currentPingpongQuantita}
                    duration={this.state.currentPingpongDuration}
                    addon={this.state.currentPingpongAddon}
                    amount={pingpongAmount}
                  />
                </CustomizeOptions>
              </Customize>
            </TabSlider>
          </Element>
          {/* PANNA 1vs1 */}
          <Element name='panna 1vs1' >
            <SplitSection slides={pannaSlides1} reverse>
              <Typography variant='h2' type='title'>PANNA 1vs1</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {panna.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UListNormal>
                {panna.technical}
              </UListNormal>
            </SplitSection>
            <TabSlider
              slides={pannaSlides2}
              tabs={panna.tabs}
              title='Personalizzazione'
              customize
            >
              <Customize>
                <CustomizeHeading>NOLEGGIA PANNA 1vs1</CustomizeHeading>
                <CustomizeOptions>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Quantita'
                      list={this.state.quantita}
                      default={this.state.currentPannaQuantita}
                      selected={this.handlePannaQuantitySelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Durata'
                      list={durations}
                      default={durations[0]}
                      selected={this.handlePannaDurationSelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      title='Personalizzazione'
                      list={pannaAddonOptions}
                      default={this.state.currentPannaAddon}
                      selected={this.handlePannaAddonSelection.bind(this)}
                    />
                  </FormGroup>
                  <PriceSection
                    product={this.props.pannaProduct}
                    quantity={this.state.currentPannaQuantita}
                    duration={this.state.currentPannaDuration}
                    addon={this.state.currentPannaAddon}
                    amount={pannaAmount}
                  />
                </CustomizeOptions>
              </Customize>
            </TabSlider>
          </Element>
        </Content>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              4 BUONI MOTIVI PER SCEGLIERE LE NOSTRE STRUTTURE
            </Typography>
          </BigTitle>
          <Features>
            {features.map(feature => (
              <FeatureWrapper>
                <Feature
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </FeatureWrapper>
            ))}
          </Features>
        </Section>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    durations: state.calculator.durations,
    products: state.calculator.products,
    pannaProduct: state.calculator.products[5],
    calcioProduct: state.calculator.products[6],
    pingpongProduct: state.calculator.products[7],
    teqballProduct: state.calculator.products[8]
  }
}

export default connect(mapStateToProps, { fetchDurations, fetchProducts })(Altre)



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/Altre.js